module.exports = __webpack_public_path__ + "static/media/img7.e2fa2f9d.jpg";